import React from "react";

export default function DegradedBadge({ compact }) {
  return (
    <span
      title="Connexion instable"
      style={{
        position: "absolute",
        top: compact ? "6px" : "10px",
        right: compact ? "6px" : "10px",
        zIndex: 3,
        display: "flex",
        alignItems: "center",
        gap: "4px",
        color: "#fff",
        fontSize: compact ? "9px" : "11px",
        fontWeight: 600,
        backgroundColor: "rgba(200,40,40,0.85)",
        padding: "2px 8px",
        borderRadius: "12px",
        pointerEvents: "none",
        whiteSpace: "nowrap",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: "7px",
          height: "7px",
          borderRadius: "50%",
          backgroundColor: "#fff",
        }}
      />
      Connexion instable
    </span>
  );
}
